import type { SkinManifest } from '@/shared/theme/orange-sports-skin';

const publicBase = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
const skinRoot = `${publicBase}skins/oro-mx-h5`;

/**
 * Oro Casino MX H5。素材/尺寸抄自 https://orocasino.mx/，与 lor-us / gc987 完全独立。
 */
export const oroMxH5Skin: SkinManifest = {
  assets: {
    avatar: `${skinRoot}/brand/avatar.png`,
    chests: {
      claimable: `${skinRoot}/brand/treasure-chest.png`,
      locked: `${skinRoot}/brand/treasure-chest.png`,
      opened: `${skinRoot}/brand/treasure-chest.png`,
    },
    hero: `${skinRoot}/banners/1.webp`,
    logo: `${skinRoot}/brand/life-logo.png`,
    pixQr: `${skinRoot}/brand/life-logo.png`,
  },
  brandName: 'Oro Casino',
  campaigns: [
    {
      accent: 'gold',
      cta: 'Depositar',
      eyebrow: 'Bienvenida',
      image: `${skinRoot}/banners/1.webp`,
      key: 'oro-welcome',
      reward: 'MXN',
      subtitle: 'Tu bono de primer depósito',
      title: 'Oro Casino México',
      to: '/deposit',
    },
  ],
  categories: [
    {
      active: true,
      image: `${skinRoot}/icons/popular.png`,
      label: 'Popular',
      subtitle: 'Slots',
      type: 'popular',
    },
  ],
  code: 'oro-mx-h5',
  games: [],
};

export const oroMxThemeTokenUrl = `${skinRoot}/theme-tokens.json`;
